import Image from 'next/image';
import Link from 'next/link';

import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Article } from '@/shared/components/article';
import { ContactModal } from '@/shared/components/contact-modal';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';

export const MainIndividualLessons = () => {
  return (
    <Article tag="main">
      <div className="grid grid-cols-1 items-center gap-x-5 sm:grid-cols-[1fr_minmax(200px,_40%)] sm:gap-x-10">
        <div className="mx-auto sm:mx-0">
          <div className="mb-10 sm:mb-5 sm:max-w-[620px]">
            <TextGradient
              text="Индивидуальные занятия"
              tag="h1"
              className="mb-6 text-center text-[34px] xss:text-5xl sm:mb-4 sm:text-left sm:text-4xl md:text-5xl"
            />

            <p className="mx-auto pl-6 text-sm xss:max-w-sm xss:pl-0 sm:mx-0 sm:max-w-xl sm:text-base">
              Идеальный формат, если у&nbsp;вас гибкий график&nbsp;- договариваться о&nbsp;времени занятий
              вы&nbsp;сможете непосредственно с&nbsp;преподавателем.
              <br />
              <br />
              А&nbsp;также этот формат отлично подойдет тем, кому нужны интенсивные занятия в&nbsp;очень короткие сроки:
              мы составим учебный план так, чтобы вы вовремя достигли своих целей!
            </p>
          </div>

          <div className="flex justify-center sm:block">
            <ContactModal entryPoint="INDIVIDUAL_PAGE">
              <Button variant="cta" className="px-6" aria-label="Записаться на бесплатную консультацию">
                Бесплатная консультация
              </Button>
            </ContactModal>
          </div>
        </div>

        <div className="relative hidden items-center justify-end sm:flex 2xl:justify-center">
          <div className="min-h-[500px] max-w-full">
            <Image
              className="mx-auto hidden h-full w-full object-contain sm:inline-flex"
              fill
              src="/images/individual-lessons/main.webp"
              alt="Индвидуальные занятия в школе английского anglichannka"
              loading="lazy"
            />
          </div>

          <GradientBg className="z-0 hidden sm:block" type="circle" origin="center" size={300} />
        </div>
      </div>
    </Article>
  );
};
